<script setup lang="ts">
const { isNavbarOpen } = storeToRefs(useLayoutStore())
const menuIcon = ref<'ph:x' | 'ph:list'>('ph:list')
watch(isNavbarOpen, v => v ? menuIcon.value = 'ph:x' : setTimeout(() => menuIcon.value = 'ph:list', 300))

const menuItems = [
  { label: 'Sobre', to: '#sobre' },
  { label: 'Serviços', to: '#servicos' },
  { label: 'Portfólio', to: '#portfolio' },
  { label: 'Contato', to: '#contato' },
]
</script>

<template>
  <nav class="absolute top-0 inset-x-0 z-20">
    <div
      class="container flex justify-between items-center pt-6 h-16 md:h-20 transition-all duration-500 ease-in-out"
      :class="{ 'dark text-foreground': isNavbarOpen }"
    >
      <NuxtLink to="/">
        <StrassenLogo
          class="h-10 fill-foreground stroke-foreground transition-colors duration-200"
          :class="isNavbarOpen ? 'delay-0 ease-in-out dark' : 'delay-300 ease-out'"
        />
      </NuxtLink>
      <div class="flex items-center gap-2">
        <NuxtLink v-slot="{ href, navigate }" custom>
          <Button
            as="a"
            :href="href"
            label="Entre em contato"
            class="rounded-full transition-colors duration-200"
            :class="isNavbarOpen ? 'delay-0 ease-in-out' : 'delay-300 ease-out'"
            @click="navigate"
          />
        </NuxtLink>
        <Button
          variant="ghost"
          size="icon-lg"
          aria-label="Menu"
          class="rounded-full md:size-12 transition-colors"
          :class="isNavbarOpen ? 'delay-0 ease-in-out' : 'delay-300 ease-out'"
          @click="isNavbarOpen = !isNavbarOpen"
        >
          <Icon :name="menuIcon" class="text-xl md:text-2xl" />
        </Button>
      </div>
    </div>
  </nav>
  <div
    class="dark bg-background text-foreground w-full overflow-hidden transition-all duration-500 ease-in-out"
    :class="isNavbarOpen ? 'h-94 sm:h-82 md:h-94' : 'h-10'"
  >
    <!-- the mt-2 is to account for the "peeking behind" effect of the navbar -->
    <div
      class="grid sm:grid-cols-2 mt-2 pt-20 md:pt-24 container px-0 transition-opacity duration-500 ease-in-out"
      :class="isNavbarOpen ? 'opacity-100' : 'opacity-0'"
    >
      <NuxtLink
        v-for="item in menuItems"
        :key="item.label"
        :to="item.to"
        class="
          cursor-pointer relative group px-4 h-16 last:h-22 last:pb-6 flex items-center
          sm:odd:border-r sm:text-xl sm:h-24 sm:nth-last-[-n+2]:h-30 sm:nth-last-[-n+2]:pb-6
          md:text-2xl md:h-30 md:nth-last-[-n+2]:h-36 md:nth-last-[-n+2]:pb-6
          lg:text-3xl
        "
      >
        <span
          aria-hidden="true"
          class="
            absolute inset-y-0 w-dvw h-full border-t transition-colors
            group-odd:right-0 group-even:left-0 group-hover:bg-accent sm:w-[50dvw]
          "
        />
        <span class="relative z-10" v-text="item.label" />
      </NuxtLink>
    </div>
  </div>
</template>
